var _circle, _circle2, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _circle3, _path4, _circle4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBanking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 104,
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 88,
    stroke: "#D9D9DE",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 81.9086C24 78.3966 26.2906 75.2952 29.6473 74.2624L125.647 44.7239C127.18 44.2522 128.82 44.2522 130.353 44.7239L226.353 74.2624C229.709 75.2952 232 78.3966 232 81.9086V96C232 100.418 228.418 104 224 104H32C27.5817 104 24 100.418 24 96V81.9086Z",
    fill: "white",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.412 56.7362C127.795 56.6182 128.205 56.6182 128.588 56.7362L218.588 84.4285C219.427 84.6867 220 85.462 220 86.34V90C220 91.1045 219.105 92 218 92H38C36.8954 92 36 91.1045 36 90V86.34C36 85.462 36.5726 84.6867 37.4118 84.4285L127.412 56.7362Z",
    fill: "white",
    stroke: "#EEEEF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.094 65.9417C127.453 65.1722 128.547 65.1722 128.906 65.9416L131.665 71.8521C131.764 72.065 131.935 72.2361 132.148 72.3354L138.058 75.0938C138.828 75.4529 138.828 76.5471 138.058 76.9062L132.148 79.6646C131.935 79.7639 131.764 79.935 131.665 80.1479L128.906 86.0583C128.547 86.8278 127.453 86.8278 127.094 86.0583L124.335 80.1479C124.236 79.935 124.065 79.7639 123.852 79.6646L117.942 76.9062C117.172 76.5471 117.172 75.4529 117.942 75.0938L123.852 72.3354C124.065 72.2361 124.236 72.065 124.335 71.8521L127.094 65.9417Z",
    fill: "#EEEEF0",
    stroke: "#B9BAC0",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 200,
    width: 192,
    height: 12,
    rx: 4,
    fill: "white",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 212,
    width: 200,
    height: 12,
    rx: 4,
    fill: "white",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 104,
    width: 28,
    height: 8,
    fill: "#F7F7F8",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 192,
    width: 28,
    height: 8,
    fill: "#F7F7F8",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 112,
    width: 16,
    height: 80,
    fill: "#F7F7F8",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 117,
    width: 4,
    height: 70,
    rx: 2,
    fill: "#D9D9DE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 104,
    width: 28,
    height: 8,
    fill: "#F7F7F8",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 192,
    width: 28,
    height: 8,
    fill: "#F7F7F8",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 112,
    width: 16,
    height: 80,
    fill: "#F7F7F8",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 117,
    width: 4,
    height: 70,
    rx: 2,
    fill: "#D9D9DE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 104,
    width: 28,
    height: 8,
    fill: "#F7F7F8",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 192,
    width: 28,
    height: 8,
    fill: "#F7F7F8",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 112,
    width: 16,
    height: 80,
    fill: "#F7F7F8",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 117,
    width: 4,
    height: 70,
    rx: 2,
    fill: "#D9D9DE"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 104,
    width: 28,
    height: 8,
    fill: "#F7F7F8",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 192,
    width: 28,
    height: 8,
    fill: "#F7F7F8",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 112,
    width: 16,
    height: 80,
    fill: "#F7F7F8",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 117,
    width: 4,
    height: 70,
    rx: 2,
    fill: "#D9D9DE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 212,
    r: 28,
    fill: "#F7F7F8",
    stroke: "#92929E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128 203.5C128.828 203.5 129.5 204.172 129.5 205V210.5H135C135.829 210.5 136.5 211.172 136.5 212C136.5 212.829 135.829 213.5 135 213.5H129.5V219C129.5 219.829 128.828 220.5 128 220.5C127.172 220.5 126.5 219.829 126.5 219V213.5H121C120.172 213.5 119.5 212.829 119.5 212C119.5 211.172 120.172 210.5 121 210.5H126.5V205C126.5 204.172 127.172 203.5 128 203.5Z",
    fill: "#92929E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 212,
    r: 20,
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148 20H156H168L164 30L168 40H148V20Z",
    fill: "#F7F7F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M148 40H168L164 30L168 20H156M148 40V20H156M148 40L156 34V20",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M148 24V40L156 36V24H148Z",
    fill: "#EEEEF0",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128 16H156V36H128V16Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128 36H156V16H128V36ZM128 36V43.5",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanking);
export default __webpack_public_path__ + "static/media/banking.91c1761dcde6299c486fec9bcd6073a2.svg";
export { ForwardRef as ReactComponent };